(() => {
  const normalize = (value) => String(value || '')
    .toLocaleLowerCase('tr-TR')
    .replace(/\u0131/g, 'i')
    .replace(/\s+/g, ' ')
    .trim();

  const isPrintedThousand = (value) => /^1000 adet\s*(?:\(\s*baskili\s*\)|baskili|baski var)$/.test(normalize(value));

  const findIntegrationQuantityKey = (propertyMap) => Object.keys(propertyMap || {})
    .find((key) => normalize(key) === '1000 adet') || null;

  window.KutufixVariantOptions = Object.freeze({
    normalize,
    isPrintedThousand,
    findIntegrationQuantityKey
  });
})();
